module.exports = __webpack_public_path__ + "media/images/react/search/question-d88b12a81bdc380feff2484b3457dff0.svg";